import { MESSAGE_CHANNEL } from "../../../../packages/constants";
import { getMessageData } from "./get-message-data";
import type { ApiMessage, Message } from "../../types";

export const getMessageDataCallback =
  (channel: MESSAGE_CHANNEL) =>
  (acc: Array<Message>, message: ApiMessage): Array<Message> => {
    const providedMessage = getMessageData(message, channel);

    return providedMessage ? [...acc, providedMessage] : acc;
  };
